import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Typography } from '@mui/material';
import { ModalsKeys } from '../../../global';
import { useModal } from '../../../hooks/useModal';
import { QuoteProgramDialogFormValues } from '../types';
import { RadioGroupField } from 'components/form';
import { useForm, useWatch } from 'react-hook-form';

export const QuoteProgramDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.QuoteProgramDialog);

  const { control, handleSubmit } = useForm<QuoteProgramDialogFormValues>({
    defaultValues: {
      financeProgramId: '',
    },
  });
  const financeProgramId = useWatch({ control, name: 'financeProgramId' });

  const handleConfirmClick = (formData: QuoteProgramDialogFormValues) => {
    data.onConfirm(data.lenderProfileId, formData.financeProgramId);
    handleClose();
  };

  return (
    <Dialog open={isOpen} fullWidth onClose={handleClose}>
      <DialogTitle>Quote Program</DialogTitle>
      <DialogContent dividers>
        <Typography component="p" variant="h6" fontSize={16} mb={1}>
          Select Program
        </Typography>
        <FormControl>
          <RadioGroupField
            control={control}
            name="financeProgramId"
            options={data.financePrograms.map(financeProgram => ({
              label: financeProgram.nameInternal,
              value: financeProgram.financeProgramId,
            }))}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit(handleConfirmClick)} disabled={!financeProgramId}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
